import React from 'react';
import Grid from '@material-ui/core/Grid'
import {AutocompleteArrayInput, LongTextInput, NumberInput, ReferenceArrayInput, required} from 'react-admin';
import env from "../../env/env";

const QuestionGroupFields = props => (
    <React.Fragment>
        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '100%'}} multiline={true} rows={10} source="title"
                           validate={required()} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <LongTextInput style={{width: '100%'}} multiline={true} rows={10} source="description"  {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <NumberInput defaultValue={1} source="displayIndex" validate={required()} {...props} />
        </Grid>
        <Grid item xs={12} sm={6}>
            <ReferenceArrayInput
                label="resources.questionGroups.fields.questionIds"
                source="questionIds"
                reference="questions" {...props}>
                <AutocompleteArrayInput optionText={"title"}/>
            </ReferenceArrayInput>
        </Grid>
        {props.record.id &&
        <Grid item xs={12} sm={12}>
            <img src={`${env.reportURL}/file/vote/${props.record.imagePath}`}
                 alt="" style={{maxWidth: '250px'}}
            />
        </Grid>
        }

    </React.Fragment>
)

export default QuestionGroupFields
